import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthUserStateService } from 'src/app/core/state/auth-user-state.service';
import { GlobalStateService } from 'src/app/core/state/global-state.service';
import { HeaderTopMenuComponent } from 'src/app/features/header-top-menu/header-top-menu.component';
import { SidemenuComponent } from 'src/app/features/sidemenu/sidemenu.component';

@Component({
    selector: 'app-main-layout',
    imports: [RouterOutlet, TranslateModule, HeaderTopMenuComponent, SidemenuComponent],
    templateUrl: './main-layout.component.html'
})
export class MainLayoutComponent {
    // Section: SERVICES / DEPENDENCIES
    //----------------------------------------------------------------------
    private globalState = inject(GlobalStateService);
    private authUserState = inject(AuthUserStateService);

    // Section: SIGNALS, OBSERVABLES AND STATE REACTIVE
    //----------------------------------------------------------------------
    isAuthenticated = this.authUserState.isAuthenticated;
    isSidemenuVisible = this.globalState.isSidemenuVisible;
    isSidemenuHidden = this.globalState.isSidemenuHidden;
    openedMenuMobileSize = this.globalState.openedMenuMobileSize;
    inmobile = this.globalState.inmobile;

    isHeaderHidden = this.globalState.isHeaderHidden;
}
